import { IS_PLAYWRIGHT } from "@util/constant";

export const IS_LAZY_LOAD_DEFAULT_VALUE = IS_PLAYWRIGHT ? "eager" : "lazy";
